"use client"
import React, { useState, useEffect, useRef, version } from 'react';

import DataTableListGenerica from '../DataTableListGenerica/DataTableListGenerica'
import DataTableGenerica from './DataTableGenerica'
import DataTableGenericaCalificacion from './DataTableGenericaCalificacion'
import DataTableListGenericaRaw from '../DataTableListGenerica/DataTableListGenericaRaw'



import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Message } from 'primereact/message';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import AuthStorage from '../../storage/AuthStorage';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import Link from 'next/link';



import Document from './Document';

import lodash from "lodash";
import crypto from "crypto-js";
import { Exception } from 'sass';


const FormularioStep = React.forwardRef((props, ref) => {

    console.log("FormularioStep, ");
    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();
    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const genericaSistemaService = new GenericaSistemaService();

    const etiquetasModulo = props.etiquetasModulo;
    //const selectedTipoGenerica = props.selectedTipoGenerica;

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    //const [modoEdicion, setModoEdicion] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(true);

    const metadataGenericaSistemaForm = props.metadataGenericaSistemaForm;
    const [selectedColumns, setSelectedColumns] = useState([]);
    const genericaSistemaDialog = props.genericaSistemaDialog;

    const genericaSistemaDialogRef = useRef(null);
    const toast = useRef(null);

    const _ = lodash;

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);


    const prevSelectedTipoGenericaRef = useRef(undefined);



    const lazyParamInit = {
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            //'ctiTexto': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const [guidIntento, setGuidIntento] = useState(window.crypto.randomUUID());

    const [lazyParams, setLazyParams] = useState(undefined);
    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));


    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    const [selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO, setSelectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO, setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE, setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE, setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS, setSelectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS] = useState(undefined);
    const [selectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS_ALL, setSelectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS_ALL] = useState(undefined);

    const [camposAMostrar_FORMULARIO_CALIFICACION_INTENTO, setCamposAMostrar_FORMULARIO_CALIFICACION_INTENTO] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO, setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE, setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE] = useState("");
    const [camposAMostrar_FORMULARIO_GENERICO_DETALLE, setCamposAMostrar_FORMULARIO_GENERICO_DETALLE] = useState("");

    const [metadataGenericaSistemaForm_FORMULARIO_CALIFICACION_INTENTO, setMetadataGenericaSistemaForm_FORMULARIO_CALIFICACION_INTENTO] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE] = useState([]);
    const [metadataGenericaSistemaForm_FORMULARIO_GENERICO_DINAMICOS, setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DINAMICOS] = useState([]);

    const [genericasSistema_FORMULARIO_CALIFICACION_INTENTO, setGenericasSistema_FORMULARIO_CALIFICACION_INTENTO] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO, setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_NOTAPADRE, setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE] = useState(null);
    const [genericasSistema_FORMULARIO_GENERICO_DETALLE, setGenericasSistema_FORMULARIO_GENERICO_DETALLE] = useState(null);

    const [genericaSistema, setGenericaSistema] = useState({ ...props.genericaSistema });

    if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) || props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema_FORMULARIO_CALIFICACION_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema_FORMULARIO_CALIFICACION_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
            setGenericasSistema_FORMULARIO_CALIFICACION_INTENTO(null);
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(null);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(null);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE(null);
        }

    }

    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [editando, setEditando] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [mensajeFiltroUtsValido, setMensajeFiltroUtsValido] = useState("");

    //const [genericaSistema, setGenericaSistema] = useState(emptyGenericaSistemaInit); 


    ref = genericaSistemaDialogRef

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    useEffect(() => {


        if (selectedTipoGenerica.tipoOrganizacionContenido === "FORMULARIO_STEPS" || selectedTipoGenerica.tg ==="BPM_VSTA_SOLICITUD_GEN_ASESOR_MOD_NEW_STEP") {

            let prevselectedTipoGenerica = { ...selectedTipoGenerica }
            let isEmpty = _.isEqual({}, selectedTipoGenerica);

            if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined && !isEmpty) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 0;
            }
            else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined && !isEmpty) {

                if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = 0;
                }
                else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
                }
                else {
                    //console.log("setLazyParams");
                    setLazyParams({ ...lazyParams });
                }

            }

            prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

        }

    }, [selectedTipoGenerica])

    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        //lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "") {

            if ((selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                    let newSelectedTipoGenerica = data.data;

                    if (selectedTipoGenerica.filtroUts !== undefined) {
                        newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                        newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                    }
                    if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenerica.variableRestriccionExterna = {};
                    }

                    if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (selectedTipoGenerica.version !== undefined) {
                        newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                    }

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                });
            }

            //else{}
            
            if (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0) {
                console.log("entro");
                //else if (metadataGenericaSistema.length === 0 && selectedTipoGenerica.operaciones !== undefined) {

                await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {


                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    /*data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });*/

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = [...data];
                    //let _metadataGenericaSistemaTgOperaciones = data.map(x => x);
                    //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    if (dataRef.length > 0) {

                        setSelectedColumns([]);
                        //setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        //lazyParamInit.filters = createHeaderGenerica(dataForm);

                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data);

                        /*
                        setMetadataGenericaSistemaRef([...dataRef]);
                        setMetadataGenericaFormulario([...dataForm]);
                        setMetadataGenericaFormularioFactura([...dataForm]);

                        setSelectedTipoGenericaFormulario({ ...selectedTipoGenerica });
                        setSelectedTipoGenericaFormularioFactura({ ...selectedTipoGenerica });

                        */

                        if (selectedTipoGenerica.operaciones) {
                            let _canEditRow = selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW");
                            //setCanEditRow( (props.canEditRow | true) && selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));
                        }

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(_metadataGenericaSistemaTgOperaciones, false, guidIntento);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;


                    }

                });





            }
        }

    }

    const establecerTipoGenericasFORMULARIO_CALIFICACION = (_metadataGenericaSistemaTgOperaciones, editando, guidIntento) => {

        let clasificadorOperacionTg = editando === true ? "TMP" : "PROD";

        let tipoTgRef = "FORMULARIO_CALIFICACION_INTENTO";

        let metadataTgOperacionTgRef = [];
        let operaciontgRef = {};
        let encontrado = false;
        let newSelectedTipoGenericaTgRef = {};

        let newFiltroUts = { ...selectedTipoGenerica.filtroUts };

        if (editando) {
            newFiltroUts['guidIntento'] = guidIntento;
        }


        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionTg
            )//)
                break;
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        var guid = window.crypto.randomUUID();

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }

        let newitemFORMULARIO_CALIFICACION_INTENTO = { ...newSelectedTipoGenericaTgRef };

        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_CONSOLIDADO";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};
        encontrado = false;

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionTg
            )//&& operaciontgRef.tipoOperacion === "EDIT")
            {
                encontrado = true;
                break;
            }
        }

        if (!encontrado) {
            alert("No encontrado:  " + tipoTgRef);
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }


        let newitemFORMULARIO_GENERICO_CONSOLIDADO = { ...newSelectedTipoGenericaTgRef };


        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_NOTAPADRE";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};
        encontrado = false;

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionTg
            )//&& operaciontgRef.tipoOperacion === "EDIT")
            {
                encontrado = true;
                break;
            }
        }

        if (!encontrado) {
            alert("No encontrado:  " + tipoTgRef);
        }

        //metadataTgOperacionTgRef = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }


        let newitemFORMULARIO_GENERICO_NOTAPADRE = { ...newSelectedTipoGenericaTgRef };

        //-------------
        tipoTgRef = "FORMULARIO_GENERICO_DETALLE";
        metadataTgOperacionTgRef = [];
        operaciontgRef = {};
        newSelectedTipoGenericaTgRef = {};
        encontrado = false;

        for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
            operaciontgRef = selectedTipoGenerica.operaciones[i];
            if (operaciontgRef.seccion === tipoTgRef && operaciontgRef.tipoOperacion === "DATASET_FORMULARIO"
                && operaciontgRef.clasificador === clasificadorOperacionTg
            )//&& operaciontgRef.tipoOperacion === "EDIT")
            {
                encontrado = true;
                break;

            }
        }

        if (!encontrado) {
            alert("No encontrado:  " + tipoTgRef);
        }


        newSelectedTipoGenericaTgRef = {
            tg: operaciontgRef.tgRef,
            cti: operaciontgRef.ctitgRef,
            ctiTexto: operaciontgRef.ctiTextotgRef,
            orden: operaciontgRef.ordentgRef,
            cgCampo: operaciontgRef.cgCampotgRef,
            operaciones: undefined,
            version: guid,
            variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
            filtroUts: { ...newFiltroUts },
            ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts,

        }

        let newitemFORMULARIO_GENERICO_DETALLE = { ...newSelectedTipoGenericaTgRef };

        setSelectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO(newitemFORMULARIO_CALIFICACION_INTENTO);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO(newitemFORMULARIO_GENERICO_CONSOLIDADO);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE(newitemFORMULARIO_GENERICO_NOTAPADRE);
        setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE(newitemFORMULARIO_GENERICO_DETALLE);


        setCamposAMostrar_FORMULARIO_CALIFICACION_INTENTO("guid,intentoCalificacion");

        let _camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO = "estadoSolicitud,ctiTextoestadoSolicitud";
        setCamposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO(_camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO);
        setCamposAMostrar_FORMULARIO_GENERICO_NOTAPADRE("estadoSolicitud,ctiTextoestadoSolicitud");
        setCamposAMostrar_FORMULARIO_GENERICO_DETALLE("estadoSolicitud,ctiTextoestadoSolicitud");

        setMetadataGenericaSistemaForm_FORMULARIO_CALIFICACION_INTENTO(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_CALIFICACION_INTENTO.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));

        let _metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO = _metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_CONSOLIDADO.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO(_metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO);
        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_NOTAPADRE.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));
        setMetadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === newitemFORMULARIO_GENERICO_DETALLE.tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));

        let newSelectedColumns = [];
        newSelectedColumns = _metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO.filter(col => (_camposAMostrar_FORMULARIO_GENERICO_CONSOLIDADO.includes(col.campo)));

        setSelectedColumns(newSelectedColumns);

    }

    useEffect(() => {

        console.log("lazyParams, ",lazyParams);
        if (lazyParams !== undefined && selectedTipoGenerica !== undefined
            && selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE !== undefined
            && selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE !== undefined
        ) {
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps



    const loadLazyData = async () => {

        console.log("loadLazyData");
        //setLoading(true);

        //if (loadLazyTimeout) {
        //clearTimeout(loadLazyTimeout);
        //}v

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        let filtroUts = {};
        let _filtroUtsValido = true;
        let _mensajeFiltroUtsValido = "";

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                    if (selectedTipoGenerica.filtroUts[campo] === null || selectedTipoGenerica.filtroUts[campo] === undefined) {
                        _filtroUtsValido = false;
                        let campoInvalido = metadataGenericaSistema.find(x => x.tg === selectedTipoGenerica.tg && x.campo === campo);
                        _mensajeFiltroUtsValido = _mensajeFiltroUtsValido + ", " + campoInvalido.ctiTexto;
                    }

                }
            }
        }

        if (editando) {
            filtroUts['guidIntento'] = guidIntento;
        }

        //setFiltroUtsValido(_filtroUtsValido);

        if (!_filtroUtsValido) {

            _mensajeFiltroUtsValido = _mensajeFiltroUtsValido.substring(2, _mensajeFiltroUtsValido.length);

            setMensajeFiltroUtsValido("Para continuar, primero seleccione: " + _mensajeFiltroUtsValido);

            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([]);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE([]);
            setGenericasSistema_FORMULARIO_GENERICO_DETALLE([]);

            //setTotalRecords(0);
            //setLoading(false);
            //setComodin(prev => prev + 1);


        }
        else {
            setMensajeFiltroUtsValido("");
            let clasificadorOperacionTg = editando === true ? "TMP" : "PROD";

            await genericaSistemaService.getGenericasSistemaDS(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts, clasificadorOperacionTg).then(async (data) => {
                //setMetadataGenericaSistema(data.metadata);

                console.log("getGenericasSistemaDS,");

                if (data.metadata.length > 0
                    //&& selectedTipoGenerica.tipoTabla == "10" 
                    //&&  ((metadataGenericaSistema.find(x => x.idTipoAtributo >= 999) === undefined) 
                    //&& (data.metadata.find(x => x.idTipoAtributo >= 999) !== undefined))
                ) {
                    //if ( selectedTipoGenerica.tipoTabla =="10" && data.metadata.length>0 && (( metadataGenericaSistema.length===0) || ( metadataGenericaSistema.length>0 && data.metadata[0].tg !== metadataGenericaSistema[0].tg )) ){

                    let dataRef = data.metadata.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    let _metadataGenericaSistemaTgOperaciones = data.metadata;
                    let newSelectedColumns = data.metadata;//metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                    let dataForm = newSelectedColumns;

                    if (dataRef.length > 0) {

                        //setSelectedColumns([]);

                        setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        lazyParamInit.filters = {};
                        //lazyParamInit.filters = createHeaderGenerica(dataForm);
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data.metadata);

                        //setMetadataGenericaSistemaRef(dataRef);
                        //setMetadataGenericaFormulario(dataForm);
                        //setMetadataGenericaFormularioFactura(dataForm);

                        //setSelectedTipoGenericaFormulario(selectedTipoGenerica);
                        //setSelectedTipoGenericaFormularioFactura(selectedTipoGenerica);

                        //setLazyParams({ ...newLazyParamInit });
                        //lazyParamsInitSelected.current = newLazyParamInit;
                        //setSelectedColumns(newSelectedColumns);

                        //if (selectedTipoGenerica.operaciones)
                        //setCanEditRow(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));

                        //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);
                        //setGenericaFormulario(emptyGenericaSistema);
                        //setGenericaFormularioFactura(emptyGenericaSistema);

                    }
                }

                //console.table(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE.tg));

                // para el intento
                var intento = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO.tg);
                setGenericasSistema_FORMULARIO_CALIFICACION_INTENTO(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO.tg));

                let genericoConsolidado = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO.tg);

                setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO(genericoConsolidado);
                let index = genericoConsolidado.findIndex(gen => gen.uts['estadoSolicitud'] === gen.uts['estadoSolicitudActual']);
                index = index >= 0 ? index : 0;

                if (activeIndex !== index) {
                    setSelectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS([]);
                }

                setActiveIndex(index);


                let genConsolidado = genericoConsolidado[index];

                setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE(data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE.tg));

                var genericoDetalle = data.data.filter(x => x.tg === selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE.tg).sort((a, b) => a.uts["orden"] - b.uts["orden"]);

                setGenericasSistema_FORMULARIO_GENERICO_DETALLE(genericoDetalle);

                var tiposAll = [];

                let index1 = genericoConsolidado.findIndex(gen => gen.uts['estadoSolicitud'] === gen.uts['estadoSolicitudActual']);

                let campoTgRefDinamico = "tgRefSolicitante";
                if (selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_CD_ASESOR_VISTA_STEP" || selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_GEN_ASESOR_VISTA_STEP") {
                    campoTgRefDinamico = "tgRef";
                }

                let keys = [];
                keys = genericoDetalle.filter(genDet => genDet.uts[campoTgRefDinamico] !==null).map(genDet => genDet.uts[campoTgRefDinamico]);

                console.log("keys,",keys);


                await genericaSistemaService.GetTipoGenericaSistemaByKeys({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, keys).then(res => {

                    for (var i in res.data) {

                        let dataDin = res.data[i];

                        console.log("GetTipoGenericaSistemaByTg,", dataDin);

                        let newSelectedTipoGenerica = dataDin;

                        if (selectedTipoGenerica.filtroUts !== undefined) {
                            newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                            newSelectedTipoGenerica.ctiTextoFiltroUts = "";//selectedTipoGenerica.ctiTextoFiltroUts
                        }
                        if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                            newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                        }
                        else {
                            newSelectedTipoGenerica.variableRestriccionExterna = {};
                        }

                        if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, dataDin.operacionesCampos)) {
                            newSelectedTipoGenerica.operacionesCampos = [...dataDin.operacionesCampos];
                        }
                        if (selectedTipoGenerica.version !== undefined) {
                            newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                        }

                        let genDet = genericoDetalle.find(x=> x.uts[campoTgRefDinamico] === dataDin.tg);

                        newSelectedTipoGenerica.estadoSolicitud = genDet.uts.estadoSolicitud;
                        newSelectedTipoGenerica.estadoSolicitudActual = genDet.uts.estadoSolicitudActual;

                        newSelectedTipoGenerica.ordenEstado = genDet.uts.ordenEstado;
                        newSelectedTipoGenerica.ordenEstadoSolicitudActual = genDet.uts.ordenEstadoSolicitudActual;

                        tiposAll.push(newSelectedTipoGenerica);

                    }

                });


                /* 
                for (var i in genericoDetalle) {

                    let genDet = genericoDetalle[i];

                    console.log("GetTipoGenericaSistemaByTg,");

                    await genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, genDet.uts[campoTgRefDinamico]).then(dataDin => {

                        let newSelectedTipoGenerica = dataDin.data;

                        if (selectedTipoGenerica.filtroUts !== undefined) {
                            newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                            newSelectedTipoGenerica.ctiTextoFiltroUts = "";//selectedTipoGenerica.ctiTextoFiltroUts
                        }
                        if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                            newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                        }
                        else {
                            newSelectedTipoGenerica.variableRestriccionExterna = {};
                        }

                        if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                            newSelectedTipoGenerica.operacionesCampos = [...dataDin.data.operacionesCampos];
                        }
                        if (selectedTipoGenerica.version !== undefined) {
                            newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                        }

                        newSelectedTipoGenerica.estadoSolicitud = genDet.uts.estadoSolicitud;
                        newSelectedTipoGenerica.estadoSolicitudActual = genDet.uts.estadoSolicitudActual;

                        newSelectedTipoGenerica.ordenEstado = genDet.uts.ordenEstado;
                        newSelectedTipoGenerica.ordenEstadoSolicitudActual = genDet.uts.ordenEstadoSolicitudActual;

                        tiposAll.push(newSelectedTipoGenerica);

                    });

                }
                */

                let selectedDinamicos = [];

                if (selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_CD_ASESOR_VISTA_STEP" || selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_GEN_ASESOR_VISTA_STEP") {
                    selectedDinamicos = [...tiposAll.filter(gen => gen['ordenEstado'] <= gen['ordenEstadoSolicitudActual'])];
                }
                else {
                    selectedDinamicos = [...tiposAll.filter(gen => gen['estadoSolicitud'] === gen['estadoSolicitudActual'])];
                }

                setSelectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS(selectedDinamicos);
                setSelectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS_ALL(tiposAll);

                console.log("selectedDinamicos, ",selectedDinamicos);
                //setGenericasSistema(data.data)
                //setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
                //setLoading(false);
                //setComodin(prev => prev + 1);

            });

        }

    }

    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['tg'] = selectedTipoGenerica.tg;
        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;
            else {

                let newVal = "";
                if (selectedTipoGenerica.filtroUts !== undefined && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo)) {
                    newVal = selectedTipoGenerica.filtroUts[x.campo];

                }

                item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }
            }
        });


        return item;

    }

    const onBooleanChange = (e, campo) => {

        const val = (e.checked && e.checked) || false;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    const onInputChange = (e, campo) => {


        const val = (e.target && e.target.value) || e.htmlValue || '';
        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);
    }

    const onInputNumberChange = (e, campo) => {
        const val = e.value || 0;

        let _genericaSistema = { ...genericaSistema };

        if (metadataGenericaSistemaForm.find(x => x.campo === campo))
            _genericaSistema['uts'][`${campo}`] = val;
        else
            _genericaSistema[`${campo}`] = val;

        setGenericaSistema(_genericaSistema);

    }

    /*
    useEffect(() => {
        if (genericaSistemaDialog && metadataGenericaSistemaForm.length > 0) {
            setTimeout(() => {
                
                let tieneFoco = false;
                for ( let i in metadataGenericaSistemaForm)
                  {

                    let primerCampo = metadataGenericaSistemaForm[i];
                    
                    switch (primerCampo.tipoDato) {
                        case "boolean": primerCampo.formRef.getElement().focus(); break;
                        case "date":  break;
                        case "ref":   break;
                        case "label":   break;
                        case "file":   break;
                        default:  if (primerCampo.formRef!== null){
                            primerCampo.formRef && primerCampo.formRef.inputRef ? primerCampo.formRef.inputRef.current.focus() : primerCampo.formRef.focus(); 
                            tieneFoco=true;
                            break;
                            }
                            else break;
                            
                    }

                    if (tieneFoco)
                        break;

                }

                
            }, 100);

        }

    }, [genericaSistemaDialog]);*/


    const generarCamposFormularioGenericaSistemaSeleccionada = () => {

        //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

        //console.log("metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, ", selectedColumns);

        //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(

        return selectedColumns
            //.filter(x => ( x.campo === "nivelCriterioRA") || (x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false))
            .map((metadata, index, array) => {
                //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false).map((metadata, index, array) => {
                //return metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label").map((metadata, index, array) => {

                if (metadata.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(metadata.campo))) {
                    return (<></>);

                }

                else {
                    return (<>
                        <div className="field">
                            <label htmlFor={metadata.campo}>{metadata.ctiTexto}</label>
                            {generarCampo(metadata)}
                            {generarMensajeValidacionCampo(metadata)}

                        </div>

                    </>);
                }
            });

    }

    const onSelectedItem = (e, metadataRef) => {

        let _genericaSistema = { ...genericaSistema };

        const val = e['uts'][`${metadataRef.refCampoTg}`] || '';
        const ValText = Object.keys(e['uts']).includes(`ctiTexto`) ? e['uts'][`ctiTexto`] : "";

        console.log("dfdf", val, ValText);
        if (metadataGenericaSistemaForm.find(x => x.campo === metadataRef.campo)) {
            _genericaSistema['uts'][`${metadataRef.campo}`] = val;
            _genericaSistema['uts'][`ctiTexto${metadataRef.campo}`] = ValText;
        }
        else
            _genericaSistema[`${metadataRef.campo}`] = val;

        console.log("metadataRef, ", val, ValText);
        setGenericaSistema(_genericaSistema);

        if (metadataRef.formRef) {
            if (metadataRef.formRef.getElement().close) {
                metadataRef.formRef.getElement().close();
            }
            else if (metadataRef.formRef.getElement().hide)
                metadataRef.formRef.getElement().hide();
        }



    }

    const renderHeaderTemplateEditor = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }

    const headerTemplateEditor = renderHeaderTemplateEditor();

    const generarCampo = (metadata) => {

        let val = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0]['uts'][`${metadata.campo}`];
        let refTg = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };

        const valRef = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0]['uts'][`${"ctiTexto" + metadata.campo}`];

        if (metadata.actualizableEnFormulario === false) {

            switch (metadata.tipoDato) {
                case "boolean":
                    val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                    return (<Checkbox checked={val} ref={e => metadata.formRef = e} ></Checkbox>);
                case "int": return (<InputNumber value={val} ref={e => metadata.formRef = e} readOnly />);
                case "sequence": return (<InputNumber readOnly value={val} ref={e => metadata.formRef = e} onValueChange={(e) => onInputNumberChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "double": return (<InputNumber mode="decimal" value={val} ref={e => metadata.formRef = e} readOnly />);
                case "text": return (<div className="m-0" dangerouslySetInnerHTML={{ __html: val }} />);
                case "text2": return (<InputTextarea value={val} ref={e => metadata.formRef = e} onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} required onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} required onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "refDocument":


                    if (genericaSistema.id > -100) {

                        const valRefDoc = genericaSistema['uts'][`${"guid" + metadata.campo}`];

                        let sequenceTgContenedor = "";

                        if (genericaSistema['uts'][`${selectedTipoGenerica.cgCampo}`] !== undefined) {
                            sequenceTgContenedor = genericaSistema['uts'][`${selectedTipoGenerica.cgCampo}`];
                        }
                        else {

                            let guid = window.crypto.randomUUID();
                            console.log(guid);

                            sequenceTgContenedor = guid;

                        }

                        //console.log("sequenceTgContenedor, ", selectedTipoGenerica, "genericaSistema, ", genericaSistema);
                        //if (genericaSistema.id>0){
                        return (
                            <div className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>
                                <div>
                                    {(valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== "") ? (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"../file?guid=" + valRefDoc}>Adjunto</Link>) : <span>No hay archivos cargados</span>}
                                </div>

                            </div>

                        );

                    }
                    else { return (<span>Archivo no carga </span>) }
            }

        }
        else {

            switch (metadata.tipoDato) {
                case "boolean":
                    val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                    return (<Checkbox id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} checked={val} ref={e => metadata.formRef = e} onChange={(e) => onBooleanChange(e, metadata.campo)} ></Checkbox>);
                case "int": return (<InputNumber id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} onValueChange={(e) => onInputNumberChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "sequence": return (<InputNumber id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} readOnly value={val} ref={e => metadata.formRef = e} onValueChange={(e) => onInputNumberChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "double": return (<InputNumber id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} mode="decimal" value={val} ref={e => metadata.formRef = e} onValueChange={(e) => onInputNumberChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "text": return (<Editor translate='no' headerTemplate={headerTemplateEditor} style={{ height: '10rem' }} id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} onTextChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "text2": return (<InputTextarea id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} required onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "date": return (<Calendar showButtonBar yearNavigator={false} yearRange="2010:2030" showIcon dateFormat="dd/mm/yy" id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} required onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);
                case "ref2": return (<Inplace closable ref={e => metadata.formRef = e} style={{ width: '95%' }}>
                    <InplaceDisplay>
                        {valRef || val} || 'Click para editar'
                    </InplaceDisplay>
                    <InplaceContent>
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadata}></DataTableListGenerica>
                    </InplaceContent>
                </Inplace>);
                case "ref":

                    const valRef = genericaSistema['uts'][`${"ctiTexto" + metadata.campo}`];

                    let refTg = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };
                    //refTg.filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                        refTg.tg = metadata.dominioDato;
                    }*/

                    if (metadata.esSoloLectura) {
                        return (<div className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>

                            <span>{valRef}</span>

                        </div>);
                    }
                    else {
                        return (<div className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>


                            <Button id={`bt${metadata.campo}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para editar'} style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${metadata.campo}`)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                            <OverlayPanel ref={e => metadata.formRef = e} showCloseIcon style={{ width: '30rem', 'margin-top': '2%', 'margin-left': '2%' }} className="overlaypanel-demo">
                                <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadata} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                            </OverlayPanel>
                        </div>);
                    }

                case "refDep": return (<div className={classNames({ 'fieldCustom': true }, { 'p-invalid': !metadata.valido })}>

                    <Button id={`bt${metadata.campo}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Click para editar'} ref={e => metadata.formRef = e} style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${metadata.campo}`)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                    <OverlayPanel ref={e => metadata.formRef = e} showCloseIcon style={{ width: '25rem', 'margin-top': '5%', 'margin-left': '5%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadata}></DataTableListGenerica>
                    </OverlayPanel>
                </div>);

                default: return (<InputText id={`fieldEdit${metadata.tg + '-' + metadata.campo}`} value={val} ref={e => metadata.formRef = e} required onChange={(e) => onInputChange(e, metadata.campo)} className={classNames({ 'p-invalid': !metadata.valido })} />);

            }

        }


    }

    const showOverlayPanel = (e, _campo) => {
        let op = metadataGenericaSistemaForm.find(x => x.campo === _campo)
        op.formRef.toggle(e);
        //console.log(op.formRef);
        //op.formRef.visible=true;
    }

    const generarMensajeValidacionCampo = (metadata) => {

        let campo = metadata.campo;

        let val = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0]['uts'][`${campo}`];

        let tieneMensajeError = submitted && metadata.tipoDato !== "boolean" && !val && metadata.mensajeError !== "";

        let textoError = tieneMensajeError ? "is required. " + metadata.mensajeError : "";

        //console.log("validaciones campos, ", val, tieneMensajeError, textoError, metadata);

        /*
        switch (metadata.tipoDato){
            case "boolean": return (<Checkbox id={`fieldEdit${metadata.tg+'-'+campo}`} checked={ val }  ref={e => metadataRef.columnRef = e} required onChange={(e) => onBooleanChange(e, campo)} className={classNames({ 'p-invalid': submitted && !genericaSistema.ctiTexto })}></Checkbox>); break;
            case "int": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={ val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)} />); break;
            case "double": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={  val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)}  mode="decimal" />); break;
            default: return (<InputText id={`fieldEdit${metadata.tg+'-'+campo}`} value={val } ref={e => metadataRef.columnRef = e} required  onChange={(e) => onInputChange(e, campo)} className={classNames({ 'p-invalid': !metadata.valido })} />); break;
        }
        */

        return (tieneMensajeError && <small className="p-invalid">{metadata.ctiTexto} {textoError}</small>);
    }

    const confirmarCancelar = (e) => {
        confirmDialog({
            message: 'Los cambios que no haya guardado se perderán. ¿Desea descartarlos?',
            header: 'Descartar cambios',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí, descartar',
            rejectLabel: 'Seguir editando',
            acceptClassName: 'p-button-danger',
            defaultFocus: 'reject',
            accept: () => onClickBotonCancelar(e)
        });
    }

    const onClickBotonCancelar = async (e) => {

        var newGuid = window.crypto.randomUUID();
        setGuidIntento(newGuid);
        setEditando(false);

        console.log("newGuid, ", newGuid);

        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

        if (props.onHideForm) {
            setGenericasSistema_FORMULARIO_GENERICO_CONSOLIDADO([]);
            setGenericasSistema_FORMULARIO_GENERICO_NOTAPADRE([]);
            props.onHideForm(e);
        }
        else {
            lazyParamInit.filters = {};
            let newLazyParamInit = Object.assign({}, lazyParamInit);
            setLazyParams({ ...newLazyParamInit });
            lazyParamsInitSelected.current = newLazyParamInit;
        }

    }




    const savegenericaSistema = async () => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);



        let tgRefOps = selectedTipoGenerica.operacionesCampos
            .find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_COMPLETAR_INTENTO")
        if (tgRefOps) {


            //setSelectedTipoGenerica(newSelectedTipoGenerica);

            let newGenericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
            //genericaSistema.uts['guidIntento'] = newGuid;

            let genericasSistemaIntento = genericasSistema_FORMULARIO_CALIFICACION_INTENTO[0];

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    if (tgRefOps.tgRef === "ACA_ADT_INTENTO_CALIFICACION_RAP_COMPLETA"
                        || tgRefOps.tgRef === "ACA_VSTA_ADT_INTENTO_CALIFICACION_RAP_COMPLETA"
                        || tgRefOps.tgRef === "ADT_CNA_INTENTO_CALIFICACION_EVIDENCIA"
                    ) {
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaIntento.uts[itemOpsCampo.campotgRef];
                    }
                    else {
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    }
                }

            }

            setGuardando(true);
            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema).then(response => {

                if (response.mensaje === "") {


                    setTimeout(() => {

                        setGuidIntento(newGuid);
                        setEditando(false);

                        console.log("newGuid, ", newGuid);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                        toast.current.show({ severity: 'success', summary: 'Cambios guardados', detail: 'La información se actualizó correctamente.', life: 3000 });

                    }, 100);



                    //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'No se pudo guardar', detail: response.mensaje });
                }

            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'No se pudo guardar', detail: 'Ocurrió un problema de comunicación. Intente de nuevo.' });
            }).finally(() => setGuardando(false));



        }


        /*



    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

    console.log("sende, ", genericaSistema);

    let dialog = genericaSistemaDialogRef.current;

    */



    }

    const onEditarFormularioFactura = async (e) => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        let tgRefOps = selectedTipoGenerica.operacionesCampos
            .find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")
        if (tgRefOps) {


            //setSelectedTipoGenerica(newSelectedTipoGenerica);

            let newGenericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
            newGenericaSistema.uts['guidIntento'] = newGuid;

            let genericasSistemaConsolidado = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    if (itemOpsCampo.campotgRef === "matricula" && selectedTipoGenerica.tg === "FMT_FORMATO_EVALUACION-RAP_MOODLE") {
                        // esto hay que organizarlo mejor
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotgRef];
                    }
                    else {
                        newGenericaSistema.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    }

                }
            }

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {
                    genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
                }

            }*/

            setGuardando(true);
            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, newGenericaSistema).then(response => {

                if (response.mensaje === "") {


                    setTimeout(() => {

                        setGuidIntento(newGuid);
                        setEditando(true);

                        console.log("newGuid, ", newGuid);

                        establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, true, newGuid);

                        lazyParamInit.filters = {};
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;

                        toast.current.show({ severity: 'info', summary: 'Modo edición', detail: 'Ya puede modificar la información. Recuerde guardar al terminar.', life: 4000 });
                    }, 100);



                    //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'No se pudo habilitar la edición', detail: response.mensaje });
                }

            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'No se pudo habilitar la edición', detail: 'Ocurrió un problema de comunicación. Intente de nuevo.' });
            }).finally(() => setGuardando(false));



        }


        /*

    
    
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

    console.log("sende, ", genericaSistema);

    let dialog = genericaSistemaDialogRef.current;

    */



    }


    const zzzsavegenericaSistema = async () => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        await genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO.tg).then(async data => {

            let newSelectedTipoGenerica = data.data;

            if (selectedTipoGenerica.filtroUts !== undefined) {
                newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
            }
            if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
            }
            else {
                newSelectedTipoGenerica.variableRestriccionExterna = {};
            }

            if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
            }
            if (selectedTipoGenerica.version !== undefined) {
                newSelectedTipoGenerica.version = selectedTipoGenerica.version;
            }

            let tgRefOps = newSelectedTipoGenerica.operacionesCampos
                .find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_COMPLETAR_INTENTO")
            if (tgRefOps) {


                //setSelectedTipoGenerica(newSelectedTipoGenerica);

                let genericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
                //genericaSistema.uts['guidIntento'] = newGuid;

                let genericasSistemaConsolidado = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

                let itemOpsCampo = {};

                for (let i = 0; i < newSelectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === tgRefOps.id) {
                        genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
                    }

                }

                await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                    if (response.mensaje === "") {


                        setTimeout(() => {

                            setGuidIntento(newGuid);
                            setEditando(false);

                            console.log("newGuid, ", newGuid);

                            establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, false, newGuid);

                            lazyParamInit.filters = {};
                            let newLazyParamInit = Object.assign({}, lazyParamInit);
                            setLazyParams({ ...newLazyParamInit });
                            lazyParamsInitSelected.current = newLazyParamInit;

                            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

                        }, 100);



                        //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                        //setGenericasSistema(_genericasSistema);
                        //setGenericaSistemaDialog(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                    }

                });



            }
        });


        /*
 
    
    
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
 
    console.log("sende, ", genericaSistema);
 
    let dialog = genericaSistemaDialogRef.current;
 
    */



    }

    const zzzonEditarFormularioFactura = async (e) => {

        //setEditando(true);

        var newGuid = window.crypto.randomUUID();

        //console.log(selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO);

        await genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO.tg).then(async data => {

            let newSelectedTipoGenerica = data.data;

            if (selectedTipoGenerica.filtroUts !== undefined) {
                newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
            }
            if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
            }
            else {
                newSelectedTipoGenerica.variableRestriccionExterna = {};
            }

            if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
            }
            if (selectedTipoGenerica.version !== undefined) {
                newSelectedTipoGenerica.version = selectedTipoGenerica.version;
            }

            let tgRefOps = newSelectedTipoGenerica.operacionesCampos
                .find(x => x.seccion === "FORMULARIO_CALIFICACION_INTENTO_TMP" && x.tipoOperacion === "FORMULARIO_CALIFICACION_CREAR_INTENTO")
            if (tgRefOps) {


                //setSelectedTipoGenerica(newSelectedTipoGenerica);

                let genericaSistema = { id: -1, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }
                genericaSistema.uts['guidIntento'] = newGuid;

                let genericasSistemaConsolidado = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO[0];

                let itemOpsCampo = {};

                for (let i = 0; i < newSelectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = newSelectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === tgRefOps.id) {
                        genericaSistema.uts[itemOpsCampo.campotgRef] = genericasSistemaConsolidado.uts[itemOpsCampo.campotg];
                    }

                }

                await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                    if (response.mensaje === "") {


                        setTimeout(() => {

                            setGuidIntento(newGuid);
                            setEditando(true);

                            console.log("newGuid, ", newGuid);

                            establecerTipoGenericasFORMULARIO_CALIFICACION(metadataGenericaSistemaTgOperaciones, true, newGuid);

                            lazyParamInit.filters = {};
                            let newLazyParamInit = Object.assign({}, lazyParamInit);
                            setLazyParams({ ...newLazyParamInit });
                            lazyParamsInitSelected.current = newLazyParamInit;

                            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });
                        }, 100);



                        //props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);

                        //setGenericasSistema(_genericasSistema);
                        //setGenericaSistemaDialog(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                    }

                });



            }
        });


        /*

    
    
    genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

    console.log("sende, ", genericaSistema);

    let dialog = genericaSistemaDialogRef.current;

    */



    }

    const genericaSistemaDialogFooter = () => {

        console.log("editando, ", editando);
        if (editando) {

            return (<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={confirmarCancelar} disabled={guardando} />

                <Button label="Guardar cambios" icon="pi pi-check" onClick={savegenericaSistema} loading={guardando} />

            </>);

        }
        else if (props.onHideForm) {
            return (<Button label="Cerrar" icon="pi pi-times" className="p-button-text" onClick={props.onHideForm} />);
        }
        else {
            return (<></>);
        }


    }

    const onClickEditarFormularioFactura = async () => {

    }

    const [activeIndex, setActiveIndex] = useState(-1);

    const pasosContenedorRef = useRef(null);

    // centra el paso actual dentro de la fila de pasos (sin mover el resto de la página)
    useEffect(() => {
        const contenedor = pasosContenedorRef.current;
        if (!contenedor || activeIndex < 0) {
            return;
        }
        const pasoActual = contenedor.querySelector('.fs-paso-actual');
        if (pasoActual) {
            contenedor.scrollLeft = pasoActual.offsetLeft - (contenedor.clientWidth / 2) + (pasoActual.clientWidth / 2);
        }
    }, [activeIndex, genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO]);

    const items = genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO === null ? [] : genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.map((generica, index) => {

        let esActual = generica.uts["estadoSolicitud"] === generica.uts["estadoSolicitudActual"];
        let estadoPaso = esActual ? "step-actual" : (activeIndex >= 0 && index < activeIndex ? "step-completado" : "step-pendiente");

        let item = {
            label: generica.uts["ctiTextoestadoSolicitud"],
            codigo: generica.uts["estadoSolicitud"],
            itemSelectable: esActual,
            disabled: !esActual,
            className: estadoPaso,
        };
        return item;
    });


    const estadoDePaso = (index) => {
        if (index === activeIndex) return "actual";
        return (activeIndex >= 0 && index < activeIndex) ? "completado" : "pendiente";
    }

    // Pasos en una fila horizontal. En pantallas angostas la fila se desplaza de lado
    // y se centra sola en el paso actual. Los pasos no son navegables: solo informan.
    const PasosHorizontal = () => {

        return (
            <nav className="fs-pasos" aria-label="Pasos" ref={pasosContenedorRef}>
                <ol>
                    {items.map((item, index) => {
                        let estado = estadoDePaso(index);
                        return (
                            <li key={item.codigo ?? index} className={`fs-paso fs-paso-${estado}`}
                                aria-current={estado === "actual" ? "step" : undefined}>
                                <span className="fs-paso-marca" aria-hidden="true">
                                    {estado === "completado" ? <i className="pi pi-check"></i> : index + 1}
                                </span>
                                <span className="fs-paso-texto">{item.label}</span>
                            </li>
                        );
                    })}
                </ol>
            </nav>
        );
    }

    const ResumenPasoActual = () => {

        if (items.length === 0 || activeIndex < 0 || activeIndex >= items.length) {
            return (<></>);
        }

        return (
            <div className="fs-panel-encabezado">
                <div className="fs-panel-titulos">
                    <div className="fs-panel-contador">Paso {activeIndex + 1} de {items.length}</div>
                    <h3 className="fs-panel-titulo">{items[activeIndex].label}</h3>
                </div>
                {editando
                    ? <span className="formulario-step-estado formulario-step-estado-editando"><i className="pi pi-pencil mr-2"></i>Editando</span>
                    : (!modoEdicion && <span className="formulario-step-estado"><i className="pi pi-eye mr-2"></i>Solo lectura</span>)}
            </div>
        );
    }

    const FormularioFacturaHeader = () => {

        let permiteCambiarCalificacion = genericaSistema !== undefined && (
            (genericaSistema.tg === "FMT_FORMATO_EVALUACION-RAP_MOODLE" && genericaSistema.uts["VistaMoodle"] === "viewUpdateGradeRA")
            || genericaSistema.tg === "FMT_FORMATO_EVALUACION-RAP"
            || genericaSistema.tg === "FMT_FORMATO_EVALUACION-EVIDENCIA_AUTOEVALUACION");

        return (
            <div className="formulario-step-header">

                <ResumenPasoActual></ResumenPasoActual>

                {modoEdicion && !editando && permiteCambiarCalificacion &&
                    <div className="flex justify-content-end mb-3">
                        <Button label="Cambiar calificación" icon="pi pi-pencil" outlined onClick={onEditarFormularioFactura} loading={guardando} />
                    </div>}

                {modoEdicion && editando &&
                    <Message severity="info" className="w-full justify-content-start mb-3"
                        text="Está modificando la información de este paso. Cuando termine, presione «Guardar cambios» al final del formulario." />}
            </div>
        );
    }

    const onChangeDataInterno = (e, metadataRef) => {
    }

    const onSaveSuccessfullDataTableDinamica = (valuesAffected) => {

        var newGuid = window.crypto.randomUUID();
        //console.log("valuesAffected, ", guidVersion.current, valuesAffected);
        //guidVersion.current = window.crypto.randomUUID();

        //setSelectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO({ ...selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO, version: newGuid });
        //setSelectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO({ ...selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO, version: newGuid });
        //setSelectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE({ ...selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE, version: newGuid });
        // no se refrezcan los detalles porque el refrezco es muy evidente
        //setSelectedTipoGenerica_FORMULARIO_GENERICO_DETALLE({...selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE, version: newGuid});

        setLazyParams({ ...lazyParams });

    }

    const generarTablaDinamicaSeleccionada = () => {

        console.log("generarTablaDinamicaSeleccionada, ");

        //let primerCampo = metadataGenericaSistema.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0))[0];

        //console.log("metadataGenericaSistemaForm_FORMULARIO_GENERICO_CONSOLIDADO, ", selectedColumns);

        //return metadataGenericaSistemaForm.filter(col => selectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && col.esImprimible > 0)).map((metadata, index, array)=>(
        /*
                     <DataTableGenerica canEditRow={modoEdicion && editando} selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                            onSelectedItem={onSelectedItem} onChangeDataInterno={onChangeDataInterno}
                            metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                            //metadataRef={metadataGenericaSistemaForm}
                            genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                            camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                            onSaveSuccessfull={onSaveSuccessfullDataTableGenericaCalificacion}
                        >
        
                        </DataTableGenerica>*/

        if (selectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS && selectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS.length > 0) {

            return selectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS
                //.filter(x => ( x.campo === "nivelCriterioRA") || (x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.actualizableEnFormulario === true && x.esSoloLectura === false))
                .map((genDinamicos, index, array) => {

                    //console.log("genDinamicos, ", genDinamicos);
                    return (<>

                        <DataTableGenerica canEditRow={modoEdicion && editando}
                            selectedTipoGenerica={genDinamicos} muestraToolbar={false}
                            enfocarPrimerBoton={index === 0}
                            //onSelectedItem={onSelectedItem} onChangeDataInterno={onChangeDataInterno}
                            //metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                            //genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                            //camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                            onSaveSuccessfull={onSaveSuccessfullDataTableDinamica}
                            addSubTabMenu={props.addSubTabMenu}
                        >

                        </DataTableGenerica>
                    </>)




                });

        }

        else if (selectedTipoGenerica_FORMULARIO_GENERICO_DINAMICOS_ALL !== undefined) {
            return (
                <div className="flex flex-column align-items-center text-center p-4 text-color-secondary">
                    <i className="pi pi-check-circle text-3xl mb-2"></i>
                    <div className="text-sm">No hay información para diligenciar en este paso.</div>
                </div>
            );
        }

        else return (<Skeleton height="10rem" />);

    }

    console.log("datosStep", genericaSistemaDialog,
        "selectedColumns, ", selectedColumns,
        "selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO, ", selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO,
        "selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO", selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO,
        "selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE", selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE,
        "selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE", selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE,
        "genericasSistema_FORMULARIO_CALIFICACION_INTENTO1", genericasSistema_FORMULARIO_CALIFICACION_INTENTO,

        "genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO1", genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO,
        "genericasSistema_FORMULARIO_GENERICO_NOTAPADRE1", genericasSistema_FORMULARIO_GENERICO_NOTAPADRE,
        "genericasSistema_FORMULARIO_GENERICO_DETALLE1", genericasSistema_FORMULARIO_GENERICO_DETALLE,
    )
    const aplicaFormularioStep = genericaSistemaDialog !== false && etiquetasModulo.length > 0
        && selectedTipoGenerica !== undefined && selectedTipoGenerica.tipoOrganizacionContenido === "FORMULARIO_STEPS";

    const datosCargados = aplicaFormularioStep && selectedTipoGenerica.operaciones !== undefined
        && selectedTipoGenerica_FORMULARIO_CALIFICACION_INTENTO !== undefined
        && selectedTipoGenerica_FORMULARIO_GENERICO_CONSOLIDADO !== undefined
        && selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE !== undefined
        && selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE !== undefined
        && genericasSistema_FORMULARIO_CALIFICACION_INTENTO !== null
        && genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO !== null
        && genericasSistema_FORMULARIO_GENERICO_NOTAPADRE !== null
        && genericasSistema_FORMULARIO_GENERICO_DETALLE !== null
        && selectedColumns.length > 0
        && metadataGenericaSistemaTgOperaciones.length > 0 && genericaSistema !== undefined;

    const contenidoAcciones = (genericaSistemaDialog !== false && (editando || props.onHideForm)) ?
        (<div className="flex justify-content-end gap-2 mt-3 pt-3 border-top-1 surface-border">
            {genericaSistemaDialogFooter()}
        </div>) : (<></>);

    if (!aplicaFormularioStep) {
        return (<></>);
    }

    else if (mensajeFiltroUtsValido !== "") {
        return (
            <div>
                <Message severity="warn" className="w-full justify-content-start" text={mensajeFiltroUtsValido} />
            </div>
        );
    }

    else if (!datosCargados) {
        return (
            <div className="formulario-step-cargando" aria-busy="true" aria-label="Cargando formulario">
                <div className="flex gap-3 mb-4">
                    {[1, 2, 3, 4].map(i => (
                        <div key={i} className="flex-1 flex flex-column align-items-center gap-2">
                            <Skeleton shape="circle" size="2rem" />
                            <Skeleton width="70%" height="0.8rem" />
                        </div>
                    ))}
                </div>
                <Skeleton width="40%" height="1.5rem" className="mb-3" />
                <Skeleton height="10rem" />
            </div>
        );
    }

    else if (genericasSistema_FORMULARIO_GENERICO_CONSOLIDADO.length === 0) {
        return (
            <div className="flex flex-column align-items-center text-center p-5 text-color-secondary">
                <i className="pi pi-inbox text-4xl mb-3"></i>
                <div className="font-semibold mb-1">No hay pasos disponibles</div>
                <div className="text-sm">Esta solicitud todavía no tiene etapas para mostrar.</div>
                {contenidoAcciones}
            </div>
        );
    }

    else if (!modoEdicion)
        //console.log("selectedTipoGenerica, ", selectedTipoGenerica);
        //console.log("metadataGenericaSistemaForm, ", metadataGenericaSistemaForm);
        return (
            <div>
                <Toast ref={toast} />
                <ConfirmDialog />

                <Dialog id="dialogGenericaSistemaForm" maximizable ref={genericaSistemaDialogRef}
                    visible={genericaSistemaDialog} style={{ width: '95%' }}
                    header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto} modal className="p-fluid"
                    footer={(genericaSistemaDialogFooter())}
                    onHide={props.onHideForm} closable={props.onHideForm !== undefined}
                >

                    <FormularioFacturaHeader></FormularioFacturaHeader>





                    {generarTablaDinamicaSeleccionada()}



                </Dialog>
            </div>
        );
    else {

        return (
            <div className="formulario-step">
                <Toast ref={toast} />
                <ConfirmDialog />

                {PasosHorizontal()}

                <section className="fs-panel">

                    <FormularioFacturaHeader></FormularioFacturaHeader>

                    {generarTablaDinamicaSeleccionada()}

                    {contenidoAcciones}

                </section>

            </div>
        );

    }

    /*

    <DataTableListGenericaRaw selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE}
                    //onSelectedItem={onSelectedItem} 
                    //onChangeDataInterno={onChangeDataInterno} 
                    metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE}
                    genericasSistema={genericasSistema_FORMULARIO_GENERICO_NOTAPADRE}
                    camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE}
                >

                </DataTableListGenericaRaw>

    */
    /*
        else {
    
            return (
                <div>
                    <Toast ref={toast} />
    
    
                    <Dialog id="dialogGenericaSistemaForm" ref={genericaSistemaDialogRef}
                        visible={genericaSistemaDialog}
                        style={{ width: '100%' }} resizable={false} position='top'
                        header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto} modal className="p-fluid"
                        footer={genericaSistemaDialogFooter()}
                        onHide={props.onHideForm ? props.onHideForm : undefined}
                        closable={props.onHideForm !== undefined}
                    >
    
                        <FormularioFacturaHeader></FormularioFacturaHeader>
    
                        {generarCamposFormularioGenericaSistemaSeleccionada()}
    
                        <DataTableListGenericaRaw selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_NOTAPADRE}
                            //onSelectedItem={onSelectedItem} 
                            //onChangeDataInterno={onChangeDataInterno} 
                            metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_NOTAPADRE}
                            genericasSistema={genericasSistema_FORMULARIO_GENERICO_NOTAPADRE}
                            camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_NOTAPADRE}
                        >
    
                        </DataTableListGenericaRaw>
    
                        <DataTableGenerica canEditRow={modoEdicion && editando} selectedTipoGenerica={selectedTipoGenerica_FORMULARIO_GENERICO_DETALLE}
                            onSelectedItem={onSelectedItem} onChangeDataInterno={onChangeDataInterno}
                            metadataRef={metadataGenericaSistemaForm_FORMULARIO_GENERICO_DETALLE}
                            //metadataRef={metadataGenericaSistemaForm}
                            genericasSistema={genericasSistema_FORMULARIO_GENERICO_DETALLE}
                            camposAMostrar={camposAMostrar_FORMULARIO_GENERICO_DETALLE}
                            onSaveSuccessfull={onSaveSuccessfullDataTableGenericaCalificacion}
                        >
    
                        </DataTableGenerica>
    
    
                    </Dialog>
                </div>
            );
    
        }*/

});

export default FormularioStep;
